import { Injectable } from '@angular/core';
import { NbComponentStatus } from '@nebular/theme';
import { Observable } from 'rxjs';

export declare type AppComponentStatus = NbComponentStatus | 'secondary';

export interface ActionFooter {
  label: string;
  title?: string;
  class?: string[];
  position: 'left' | 'center' | 'right';
  outline?: boolean;
  disabled$?: Observable<boolean>;
  status?: AppComponentStatus;
  click: () => void;
  icon?: { icon: string; pack?: string; position?: 'left' | 'right' } | string;
}

@Injectable()
export class ActionsFooterService {
  actions: ActionFooter[] = [];

  add(actions: ActionFooter[]): void {
    this.actions.push(...actions);
  }

  destroy(): void {
    this.actions = [];
  }
}
